export const SUBMIT_SHOP_ID = 'registration/SUBMIT_SHOP_ID';
export const SHOP_DETAILS_SUCCESS = 'registration/SHOP_DETAILS_SUCCESS';
export const SHOP_DETAILS_FAILURE = 'registration/SHOP_DETAILS_FAILURE';
export const SHOP_CONFIRM = 'registration/SHOP_CONFIRM';
export const SHOP_REJECT = 'registration/SHOP_REJECT';
export const ACTIVATE_VIEW_ENTER = 'registration/ACTIVATE_VIEW_ENTER';
export const ACTIVATE_NEW_CARD = 'registration/ACTIVATE_NEW_CARD';
export const SET_STEP = 'registration/SET_STEP';
export const CARD_NUMBER_SUBMIT = 'registration/CARD_NUMBER_SUBMIT';
export const CARD_NUMBER_CONFIRM = 'registration/CARD_NUMBER_CONFIRM';
export const CARD_NUMBER_REJECT = 'registration/CARD_NUMBER_REJECT';
export const REGISTER_CARD_ATTEMPT = 'registration/REGISTER_CARD_ATTEMPT';
export const TERMS_CONSENT = 'registration/TERMS_CONSENT';
export const PHONE_NUMBER_CONFIRM = 'registration/PHONE_NUMBER_CONFIRM';
export const PHONE_NUMBER_REJECT = 'registration/PHONE_NUMBER_REJECT';
export const RESEND_ATTEMPT = 'registration/RESEND_ATTEMPT';
export const RESEND_CONFIRM = 'registration/RESEND_CONFIRM';
export const RESEND_REJECT = 'registration/RESEND_REJECT';

export const submitShopId = (shopId) => ({
  type: SUBMIT_SHOP_ID,
  shopId
});

export const shopDetailsSuccess = ({ shopId, shopName, city }) => ({
  type: SHOP_DETAILS_SUCCESS,
  shopId,
  shopName,
  city
});

export const shopDetailsFailure = () => ({
  type: SHOP_DETAILS_FAILURE
});

export const shopConfirm = () => ({
  type: SHOP_CONFIRM
});

export const shopReject = () => ({
  type: SHOP_REJECT
});

export const activateViewEnter = () => ({
  type: ACTIVATE_VIEW_ENTER
});

export const activateNewCard = () => ({
  type: ACTIVATE_NEW_CARD
});

export const setStep = (step) => ({
  type: SET_STEP,
  step
});

export const cardNumberSubmit = (cardNumber) => ({
  type: CARD_NUMBER_SUBMIT,
  cardNumber
});

export const cardNumberConfirm = () => ({
  type: CARD_NUMBER_CONFIRM
});

export const cardNumberReject = () => ({
  type: CARD_NUMBER_REJECT
});

export const registerCardAttempt = (phoneNumber, marketingConsent) => ({
  type: REGISTER_CARD_ATTEMPT,
  phoneNumber,
  marketingConsent
});

export const termsConsent = (accepted = true) => ({
  type: TERMS_CONSENT,
  accepted
});

export const phoneNumberConfirm = () => ({
  type: PHONE_NUMBER_CONFIRM
});

export const phoneNumberReject = () => ({
  type: PHONE_NUMBER_REJECT
});

export const resendAttempt = () => ({
  type: RESEND_ATTEMPT
});

export const resendConfirm = () => ({
  type: RESEND_CONFIRM
});

export const resendReject = () => ({
  type: RESEND_REJECT
});
